import { Button } from '@televet/kibble-ui/build/components/Button';
import { Modal, ModalBody, ModalCloseButton, ModalFooter } from '@televet/kibble-ui/build/components/Modal';
import { env } from 'env';
import React from 'react';
import IframeResizer from '@iframe-resizer/react';
import { useHistory } from 'react-router-dom';
import { RouteBasePaths } from 'routes';
import { quickSightRelativePath } from 'pages/Reporting';
import { QUICKSIGHT_DASHBOARD_URL } from 'pages/Reporting/QuickSightReports/embedDashboard';

const { REACT_APP_PAWBLISHER_URL } = env;

interface CareGoalTrackerInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  carePlanProviderGroupId: string;
}

export const CareGoalTrackerInfoModal = ({
  isOpen,
  onClose,
  carePlanProviderGroupId,
}: CareGoalTrackerInfoModalProps): JSX.Element => {
  const history = useHistory();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalCloseButton isOnContrast />
      <ModalBody p={0}>
        <IframeResizer
          license={env.REACT_APP_IFRAME_RESIZER_LICENSE}
          {...(env.REACT_APP_PRODUCTION === 'false' && { log: 'collapsed' })}
          src={`${REACT_APP_PAWBLISHER_URL}/elements/${carePlanProviderGroupId}/goalTracker`}
          checkOrigin={false}
          style={{
            width: '1px',
            minWidth: '100%',
            borderTopLeftRadius: 'var(--chakra-radii-xl)',
            borderTopRightRadius: 'var(--chakra-radii-xl)',
          }}
        />
      </ModalBody>
      <ModalFooter justifyContent="space-between">
        <Button
          variant="secondary"
          onClick={(): void => {
            history.push(
              `${RouteBasePaths.Reporting}/${quickSightRelativePath}/${QUICKSIGHT_DASHBOARD_URL.Care_Financial_Report}`,
            );
            onClose();
          }}
        >
          View Care Report
        </Button>
        <Button variant="tertiary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
